import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { createModelConceptAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/createModelConceptAttribute';
import { addProjectModelIdsToIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const addModelsToAttributeModelData =
  ({ value, projectModelIds }: { value: string; projectModelIds: string[] }) =>
  (model: Model) => {
    const existingAttribute =
      model.modelData.attributesByIri[value] ||
      createModelConceptAttribute({ value });

    setDataProperty<ModelData>(model)(model.modelData, 'attributesByIri', {
      ...model.modelData.attributesByIri,
      [value]: {
        ...existingAttribute,
      },
    });

    addProjectModelIdsToIri(value, projectModelIds)(model);
  };
